import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, CssBaseline, Tab, Tabs, Typography } from "@mui/material";

import AppBar from "../address/AppBar";
import ExclusionZones from "./ExclusionZones";

/** Paramètres propres au groupe client de l'utilisateur. Un onglet par paramètre. */
export default function Settings() {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#fafafa" }}>
      <CssBaseline />
      <AppBar
        title={t("applicationMenu.menuItem.settings")}
        position="fixed"
        sx={{ zIndex: (theme: any) => theme.zIndex.drawer + 1 }}
      />
      <Box sx={{ flex: 1, paddingTop: 10, paddingX: 3, paddingBottom: 4, maxWidth: 1400, marginX: "auto" }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          {t("settings.title")}
        </Typography>
        <Tabs value={selectedTab} onChange={(_event, value) => setSelectedTab(value)} sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}>
          <Tab label={t("settings.tab.exclusionZones")} />
        </Tabs>
        {selectedTab === 0 && <ExclusionZones />}
      </Box>
    </Box>
  );
}
